import React, { useEffect, useState } from "react";
import { Card, Col, Collapse, Form, Modal, Row, Switch, Upload } from "antd";
import Text from "../../../components/Text/Text";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import Button from "../../../components/Button/Button";
import { color, icon } from "../../../resource";
import { DeleteFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import {
  imgCropProps,
  UploadArea,
  UploadIcon,
  CustomFormItem,
  UploadBox,
  CustomFormItemHighlight,
} from "../FlashSaleStyle";
import ImgCrop from "../../../components/ImgCrop/ImgCrop";
import { ImageWithDeleteButton } from "../../../components/Image/Image";
import { getBase64 } from "../../../utility/uploadHelper";
import { RcFile } from "antd/es/upload";
import image from "../../../resource/image";
import { shopDatasource } from "../../../datasource/ShopDatasource";
import { useEffectOnce } from "react-use";
import { ModalPreviewFile, readFileAsBase64 } from "../../NewCODiscount/CODiscountComponent";
import styled from "styled-components";
import { NumberNotZero } from "../../../utility/validator";
import dayjs from "dayjs";
import { checkAvailableCode } from "../../../datasource/FlashSaleDatasource";

const StyledCollapse = styled(Collapse)`
  .ant-collapse-content-box {
    padding: 45px 20px 30px 20px !important;
  }
`;

export const FlashSaleStepOne: React.FC<{
  form: any;
}> = ({ form }) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isCreate = pathSplit[3] === "0";
  const id = pathSplit[3];

  const [fileRef, setFileRef] = useState<any>([]);
  const [fileBase64, setFileBase64] = useState<string | null>(null);
  const [openPdf, setOpenPdf] = useState(false);
  const [imgTimeSection, setImgTimeSection] = useState<any>();
  const [prodBrandList, setProdBrandList] = useState<any>([]);
  const watchImage = Form.useWatch("fileImage", form);
  const watchImageUrl = Form.useWatch("fileImageUrl", form);
  const watchImageHightLight = Form.useWatch("fileImageHightLight", form);
  const watchImageHightLightUrl = Form.useWatch("fileImageHightLightUrl", form);
  const [reviewHightLight, setReviewHightLight] = useState(false);

  const fetchProBrand = async () => {
    const res = await shopDatasource.getBrandList(userProfile?.company);
    setProdBrandList(
      res
        .filter((p) => p.isActive)
        .map((item) => ({
          label: item.productBrandName,
          value: item.productBrandId,
          key: item.productBrandId,
        })),
    );
    form.setFieldValue(
      "productBrandName",
      res.find((p) => p.productBrandId === form.getFieldValue("productBrandId"))
        ?.productBrandName || undefined,
    );
  };
  useEffectOnce(() => {
    fetchProBrand();
  });

  const defaultImage = async (brandId?: string) => {
    let filePath: string | undefined;
    let highlightImage: string | undefined;
    let timeImage: string | undefined;

    if (userProfile?.company === "ICPL") {
      if (`${brandId}` === "6") {
        filePath = image.ladda_cover_flashsale_whs;
        highlightImage = image.ladda_cover_flashsale_whs;
        timeImage = image.time_flashsale_red;
      } else {
        filePath = image.ladda_cover_flashsale_dis;
        highlightImage = image.highlight_blue_ladda;
        timeImage = image.time_flashsale_blue;
      }
    } else if (userProfile?.company === "ICPI") {
      filePath = image.inter_cover_flashsale;
      timeImage = image.time_flashsale_blue;
      highlightImage = image.highlight_blue_inter;
    } else {
      filePath = image.ladda_cover_flashsale_whs;
      timeImage = image.time_flashsale_red;
      highlightImage = image.ladda_cover_flashsale_whs;
    }
    setImgTimeSection(timeImage);

    return {
      filePath,
      highlightImage,
    };
  };

  const convertImgToFile = async (filePath: any, highlightImage: any) => {
    const file = await convertFile(filePath);
    const highlightFile = await convertFile(highlightImage);
    form.setFieldValue("fileImage", file);
    await getBase64(file as RcFile, (url) => {
      form.setFieldValue("fileImageUrl", url);
    });
    form.setFieldValue("fileImageHightLight", highlightFile);
    await getBase64(highlightFile as RcFile, (url) => {
      form.setFieldValue("fileImageHightLightUrl", url);
    });
  };

  const convertFile = async (path: any) => {
    const response = await fetch(path!);
    const blob = await response.blob();
    const fileName = (path as string)
      ? (path as string).split("/").pop() || "image.png"
      : "image.png";
    const file = new File([blob], fileName, {
      type: blob.type,
    });
    return file;
  };

  useEffect(() => {
    const init = async () => {
      let productBrandId = undefined;
      if (isCreate && id === "0") {
        productBrandId =
          userProfile?.company === "ICPL" ? "1" : form.getFieldValue("productBrandId");
        const { filePath, highlightImage } = await defaultImage(productBrandId);
        convertImgToFile(filePath, highlightImage);
      } else {
        productBrandId = form.getFieldValue("productBrandId");
        setFileRef(
          form?.getFieldValue("fileMemoUrl") ? [{ name: form?.getFieldValue("fileMemoUrl") }] : [],
        );
      }
      form.setFieldsValue({
        company: userProfile?.company,
        productBrandId,
        productBrandName: prodBrandList?.find((brand) => `${brand.key}` === `${productBrandId}`)
          ?.label,
        updateBy: `${userProfile?.firstname} ${userProfile?.lastname}`,
      });
    };
    init();
  }, []);

  const checkRoundGap = (maxGapMinutes: number) => {
    const rounds = form.getFieldValue("rounds") || [];
    return rounds.some((round, index) => {
      if (index === 0) return false;
      const previousRound = rounds[index - 1];
      const previousEnd =
        dayjs(previousRound.endDate).format("YYYY-MM-DD") +
        " " +
        dayjs(previousRound.endTime).format("HH:mm");
      const currentStart =
        dayjs(round.startDate).format("YYYY-MM-DD") + " " + dayjs(round.startTime).format("HH:mm");
      const gapMinutes = dayjs(currentStart, "YYYY-MM-DD HH:mm").diff(previousEnd, "minute");
      return maxGapMinutes > gapMinutes;
    });
  };

  return (
    <>
      <div>
        <span
          className='card-label font-weight-bolder text-dark'
          style={{ fontSize: 20, fontWeight: "bold" }}
        >
          ข้อมูลเบื้องต้น
        </span>
      </div>
      <Row justify='space-between' gutter={12}>
        <Col span={17}>
          <Form
            form={form}
            layout='vertical'
            autoComplete='off'
            initialValues={{ cartLockTime: 15, isFreeShip: false, isHighLight: true }}
          >
            <div style={{ paddingTop: "50px" }}>
              <Row gutter={8} justify='start' align='middle'>
                <Col span={5}>
                  <CustomFormItem
                    name='fileImageUrl'
                    valuePropName='file'
                    rules={[
                      {
                        required: true,
                        message: "*กรุณาเพิ่มรูป",
                      },
                    ]}
                  >
                    <ImgCrop aspect={800 / 890} {...imgCropProps}>
                      <UploadBox
                        listType='picture-card'
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isJpgOrPng =
                            file.type === "image/jpeg" || file.type === "image/png";
                          if (!isJpgOrPng) {
                            //message.error("You can only upload JPG/PNG file!");
                            return true;
                          }
                          form.setFieldValue("fileImage", file);
                          getBase64(file as RcFile, (url) => {
                            form.setFieldValue("fileImageUrl", url);
                          });
                        }}
                        onChange={({ file }: any) => {
                          return "success";
                        }}
                        onRemove={() => {
                          form.setFieldValue("fileImage", "");
                          form.setFieldValue("fileImageUrl", "");
                        }}
                        showUploadList={false}
                        disabled={
                          !!form.getFieldValue("fileImage") || !!form.getFieldValue("fileImageUrl")
                        }
                      >
                        {!watchImageUrl ? (
                          <UploadArea
                            style={{
                              width: "148px",
                              height: "148px",
                            }}
                          >
                            {UploadIcon}
                          </UploadArea>
                        ) : (
                          <ImageWithDeleteButton
                            width={"148px"}
                            height={"148px"}
                            src={form.getFieldValue("fileImageUrl")}
                            handleDelete={() => {
                              form.setFieldValue("fileImage", undefined);
                              form.setFieldValue("fileImageUrl", undefined);
                            }}
                          />
                        )}
                      </UploadBox>
                    </ImgCrop>
                  </CustomFormItem>
                </Col>
                <Col span={19}>
                  <Text level={6}>
                    ภาพหน้าปกแคมเปญ &nbsp;<span style={{ color: color.error }}>*</span>
                  </Text>
                  <br />
                  <Text level={6} color='Text3'>
                    หากไม่อัปโหลดภาพ จะใช้ภาพปก Default ตามตัวอย่างการแสดงผล
                  </Text>
                  <Text level={6} color='Text3'>
                    รูปแบบไฟล์ภาพ
                    <br />
                    JPG / PNG
                    <br />
                    ขนาดภาพ
                    <br />
                    800 x 890 px
                  </Text>
                </Col>
              </Row>
            </div>
            <br />
            <Row justify={"space-between"} gutter={8}>
              <Col span={12}>
                <Form.Item
                  label='ชื่อโปรโมชัน'
                  name='flashSaleName'
                  rules={[{ required: true, message: "โปรดระบุชื่อโปรโมชัน" }]}
                  required
                >
                  <Input placeholder='ระบุชื่อโปรโมชัน' autoComplete='off' />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label='รหัสโปรโมชัน'
                  name='promotionCode'
                  rules={[
                    { required: true, message: "โปรดระบุรหัสโปรโมชัน" },
                    {
                      validator: async (_, value) => {
                        if (value) {
                          const result = await checkAvailableCode({
                            promotionCode: value,
                            flashSaleId: form.getFieldValue("flashSaleId"),
                          });
                          if (result?.success) {
                            return Promise.reject(new Error("รหัสโปรโมชันนี้ถูกใช้แล้ว"));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                  required
                >
                  <Input
                    placeholder='ระบุรหัสโปรโมชัน'
                    autoComplete='off'
                    disabled={form.getFieldValue("isSendNav")}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify={"space-between"} gutter={8}>
              <Col span={12}>
                <Form.Item
                  label='แบรนด์สินค้าที่ต้องการขาย Flash Sale'
                  name='productBrandId'
                  rules={[{ required: true, message: "กรุณาเลือกแบรนด์สินค้า" }]}
                  required
                >
                  <Select
                    data={prodBrandList || []}
                    placeholder='เลือกแบรนด์สินค้า'
                    onChange={async (key) => {
                      if (key) {
                        form.setFieldValue(
                          "productBrandName",
                          prodBrandList.find((item) => `${item.key}` === key).label,
                        );
                        const { filePath, highlightImage }: any = await defaultImage(key);
                        convertImgToFile(filePath, highlightImage);
                      } else {
                        form.setFieldValue("productBrandName", undefined);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Text fontWeight={600}>เอกสารอ้างอิง</Text>
                <br />
                <Card bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
                  <Row gutter={8} justify={"start"}>
                    <Col span={4}>
                      <Upload
                        disabled={fileRef?.length > 0}
                        accept='.pdf,application/pdf'
                        style={{ width: "100%" }}
                        action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                        onChange={async (info) => {
                          let newFileList: any = [...info.fileList].slice(-1);
                          newFileList = newFileList.map((file) => {
                            const localFile = file.originFileObj as File | undefined;
                            if (file.response?.url) {
                              file.url = file.response.url;
                            } else if (localFile) {
                              file.url = URL.createObjectURL(localFile);
                            }
                            return file;
                          });
                          form.setFieldValue("fileMemo", newFileList[0].originFileObj);
                          setFileRef(newFileList);
                          setFileBase64(await readFileAsBase64(newFileList[0].originFileObj));
                        }}
                        fileList={fileRef}
                        beforeUpload={() => false}
                        showUploadList={false}
                      >
                        <Button
                          typeButton={fileRef?.length > 0 ? "disabled" : "primary"}
                          title='เลือกไฟล์'
                          height={40}
                        />
                      </Upload>
                    </Col>
                    <Col span={19} style={{ paddingTop: "8px" }}>
                      {fileRef?.length > 0 ? (
                        <>
                          <Text
                            color='primary'
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setOpenPdf(true);
                            }}
                          >
                            {fileRef[0]?.name?.length > 50
                              ? `${fileRef[0]?.name.slice(0, 50)}...pdf`
                              : fileRef[0]?.name}
                          </Text>
                          {openPdf && (
                            <ModalPreviewFile
                              openPdf={openPdf}
                              setOpenPdf={setOpenPdf}
                              fileRef={fileBase64 || fileRef[0]?.name}
                            />
                          )}
                        </>
                      ) : (
                        <>
                          <Col>
                            <img
                              src={icon.icon_pdf}
                              alt='PDF Icon'
                              style={{ width: "22px", height: "26px" }}
                            />{" "}
                            <Text level={6} color='Text3'>
                              โปรดเลือกไฟล์ .PDF
                            </Text>
                          </Col>
                        </>
                      )}
                    </Col>
                    {fileRef?.length > 0 && (
                      <Col style={{ paddingTop: "8px" }}>
                        <DeleteFilled
                          style={{ color: color.error }}
                          onClick={() => {
                            form.setFieldValue("fileMemo", null);
                            setFileRef([]);
                            setFileBase64(null);
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Card>
              </Col>
            </Row>
            {!form.getFieldsValue(true).highLightNewsId && (
              <>
                <br />
                <StyledCollapse
                  activeKey={[1]}
                  items={[
                    {
                      key: "1",
                      label: (
                        <>
                          <Row gutter={16} align='middle'>
                            <Col>
                              <img src={icon.icon_img} style={{ height: "28px" }} />
                            </Col>
                            <Col>
                              <Text fontWeight={600}>สร้างไฮไลท์ข่าวสาร </Text>
                              <br />
                              <Text color='Text3' level={6}>
                                เมื่อเปิดใช้งานระบบจะสร้างไฮไลท์ข่าวสารพร้อมการสร้าง Flash Sale
                                อัตโนมัติ
                              </Text>
                            </Col>
                          </Row>
                        </>
                      ),
                      extra: (
                        <Row
                          justify='end'
                          gutter={16}
                          style={{ paddingTop: "10px", alignItems: "middle" }}
                        >
                          <Col>
                            <Form.Item name='isHighLight' noStyle>
                              <Switch
                                onChange={(checked) => form.setFieldValue("isHighLight", checked)}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      ),
                      showArrow: false,
                      children: (
                        <Row gutter={8} justify='start' align='middle'>
                          <Col span={5}>
                            <CustomFormItemHighlight
                              name='fileImageHightLightUrl'
                              valuePropName='file'
                              rules={[
                                {
                                  required: true,
                                  message: "*กรุณาเพิ่มรูป",
                                },
                              ]}
                            >
                              <ImgCrop aspect={1200 / 1500} {...imgCropProps}>
                                <UploadBox
                                  listType='picture-card'
                                  maxCount={1}
                                  beforeUpload={(file) => {
                                    const isJpgOrPng =
                                      file.type === "image/jpeg" || file.type === "image/png";
                                    if (!isJpgOrPng) {
                                      //message.error("You can only upload JPG/PNG file!");
                                      return true;
                                    }
                                    form.setFieldValue("fileImageHightLight", file);
                                    getBase64(file as RcFile, (url) => {
                                      form.setFieldValue("fileImageHightLightUrl", url);
                                    });
                                  }}
                                  onChange={({ file }: any) => {
                                    return "success";
                                  }}
                                  onRemove={() => {
                                    form.setFieldValue("fileImageHightLight", "");
                                    form.setFieldValue("fileImageHightLightUrl", "");
                                  }}
                                  showUploadList={false}
                                  disabled={
                                    !!form.getFieldValue("fileImageHightLight") ||
                                    !!form.getFieldValue("fileImageHightLightUrl")
                                  }
                                >
                                  {!watchImageHightLightUrl ? (
                                    <UploadArea
                                      style={{
                                        width: "150px",
                                        height: "170px",
                                      }}
                                    >
                                      {UploadIcon}
                                    </UploadArea>
                                  ) : (
                                    <ImageWithDeleteButton
                                      width={"150px"}
                                      height={"170px"}
                                      src={watchImageHightLightUrl}
                                      handleDelete={() => {
                                        form.setFieldValue("fileImageHightLight", undefined);
                                        form.setFieldValue("fileImageHightLightUrl", undefined);
                                      }}
                                    />
                                  )}
                                </UploadBox>
                              </ImgCrop>
                            </CustomFormItemHighlight>
                          </Col>
                          <Col span={7}>
                            <Text level={6}>
                              ภาพไฮไลน์ข่าวสาร&nbsp;<span style={{ color: color.error }}>*</span>
                            </Text>
                            <br />
                            <Text level={6} color='Text3'>
                              รูปแบบไฟล์และขนาด
                              <br />
                              JPG / PNG
                              <br />
                              ขนาดภาพ
                              <br />
                              1200 x 1500 px
                            </Text>
                          </Col>
                          <Col span={12}>
                            <Text
                              color='primary'
                              style={{ cursor: "pointer" }}
                              onClick={() => setReviewHightLight(true)}
                            >
                              <u>ดูตัวอย่างการแสดงผล</u>
                            </Text>
                            <Card bodyStyle={{ padding: "12px", backgroundColor: "#FAFAFA" }}>
                              <ExclamationCircleOutlined
                                style={{ color: color.Text3, fontSize: "16px" }}
                              />
                              &nbsp;
                              <Text color='Text3' level={6}>
                                Note: วันเริ่มต้นแสดงไฮไลน์จะยืดจากการตั้งค่า
                                “วันที่ร้านเห็นแคมเปญล่วงหน้า” วันสิ้นสุดไฮไลน์จะยืดจากการตั้งค่า
                                “วันสิ้นสุด Flash Sale”
                              </Text>
                            </Card>
                          </Col>
                        </Row>
                      ),
                    },
                  ]}
                />
              </>
            )}
            <br />
            <Row>
              <Text fontWeight={600}>
                <Text fontWeight={600}>เงื่อนไข Flash Sale</Text>
              </Text>
            </Row>
            <Row>
              <Col span={24}>
                <div
                  style={{
                    border: "1px solid #E5EAEE",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    backgroundColor: "#FAFAFA",
                  }}
                >
                  <Row justify='space-between' align='middle'>
                    <Col span={16}>
                      <Row gutter={16} align='middle'>
                        <Col>
                          <img src={icon.icon_flash_cart} style={{ height: "28px" }} />
                        </Col>
                        <Col>
                          <Text fontWeight={600}>เปิดใช้งาน ล็อคตะกร้า (Cart Lock)</Text>
                          <br />
                          <Text color='Text3' level={6}>
                            ระบบจะคืนโควตา/สต็อกอัตโนมัติ
                            <br />
                            หากร้านไม่ยืนยันคำสั่งซื้อภายในเวลาที่กำหนด
                          </Text>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label='ระยะเวลาล็อคตะกร้า (สูงสุด 60 นาที)'
                        name='cartLockTime'
                        rules={[
                          { required: true, message: "กรุณาระบุระยะเวลาล็อคตะกร้า" },
                          {
                            validator: async (_, value) => {
                              if (value && value > 60) {
                                form.setFieldsValue({ cartLockTime: 60 });
                                return Promise.reject("*ระยะเวลาล็อคตะกร้าต้องไม่เกิน 60 นาที");
                              }
                              if (value && value <= 0) {
                                form.setFieldsValue({ cartLockTime: 1 });
                                return Promise.reject("*ระยะเวลาล็อคตะกร้าต้องมากกว่า 0 นาที");
                              }
                              if (value && checkRoundGap(value > 60 ? 60 : value)) {
                                return Promise.reject(
                                  "*ไม่สามารถเพิ่มเวลาล๊อคตะกร้าได้ เนื่องจากมีระยะเวลา" +
                                    "บางรอบในขั้นตอนที่ 2 ตั้งค่าติดกับเวลาล๊อคตะกร้า กรุณาแก้ไขรอบเวลาและกลับมาอีกครั้ง",
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          placeholder='ระบุระยะเวลาล็อคตะกร้า'
                          autoComplete='off'
                          suffix='นาที'
                          onKeyDown={NumberNotZero}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={24}>
                <div
                  style={{
                    border: "1px solid #E5EAEE",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    backgroundColor: "#FAFAFA",
                  }}
                >
                  <Row justify='space-between' align='middle'>
                    <Col>
                      <Row gutter={16} align='middle'>
                        <Col>
                          <img src={icon.icon_flash_truck} style={{ height: "28px" }} />
                        </Col>
                        <Col>
                          <Text fontWeight={600}>เปิดใช้งาน จัดส่งฟรี</Text>
                          <br />
                          <Text color='Text3' level={6}>
                            เฉพาะคำสั่งซื้อที่สั่งผ่านแคมเปญ Flash Sale
                          </Text>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Form.Item name='isFreeShip' valuePropName='checked' noStyle>
                        <Switch />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col span={7}>
          <div
            style={{
              borderRadius: "8px",
              backgroundColor: "#EFF2F9",
              padding: "16px",
            }}
          >
            <Text fontWeight={600}>ตัวอย่างการแสดงผล</Text>
            <div
              style={{
                width: "100%",
                position: "relative",
                backgroundColor: "#BABCBE",
                borderRadius: "24px 24px 0 0",
              }}
            >
              <img
                src={image.top_bar_flashsale}
                alt='Top Bar'
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "cover",
                  borderRadius: "8px 8px 0 0",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 2,
                }}
              />
              {form.getFieldValue("fileImageUrl") ? (
                <img
                  src={form.getFieldValue("fileImageUrl")}
                  alt='Preview'
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    objectFit: "cover",
                    borderRadius: "24px 24px 0 0",
                    position: "relative",
                    zIndex: 1,
                  }}
                />
              ) : (
                <div style={{ height: "340px" }}></div>
              )}
              <img
                src={imgTimeSection}
                alt='Flash Sale'
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  position: "relative",
                  marginTop: "-20px",
                  zIndex: 3,
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      {reviewHightLight && (
        <Modal
          open={true}
          onCancel={() => setReviewHightLight(false)}
          footer={null}
          centered
          width='380px'
        >
          <div
            style={{
              position: "relative",
              width: "100%",
            }}
          >
            <img
              src={image.flash_sale_highlight}
              alt='Highlight Preview'
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />

            <div
              style={{
                position: "absolute",
                top: "22.5%",
                left: "7%",
                right: "7%",
                overflow: "hidden",
                borderRadius: "10px",
              }}
            >
              {watchImageHightLightUrl && (
                <img
                  src={watchImageHightLightUrl}
                  alt='Highlight'
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
